import React from "react";
import { premiumData } from "./PremiumObj";

const PremiumProduct = () => {
  return (
    <div className="w-full h-full px-3 md:px-8 bg-gradient-to-r from-gray-100 to-gray-200">
      <div className="flex flex-col items-center justify-center w-full h-full">
        {/* Heading */}
        <h1 className="font-bold text-lg md:text-3xl text-center uppercase mt-5 text-[#800000]">
          Premium Collection
        </h1>

        {/* Product Section */}
        {/* Mobile -> Slider | Desktop -> Grid */}
        <div className="mt-6 w-full">
          {/* Mobile Slider */}
          <div className="flex md:hidden gap-4 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-4">
            {premiumData.map((item) => (
              <div
                key={item.id}
                className="min-w-[160px] max-w-[180px] flex-shrink-0 backdrop-blur-md bg-white/70 border border-gray-200 shadow-md rounded-xl p-3 flex flex-col items-center snap-center"
              >
                {/* Image */}
                <div className="w-full h-[140px] flex items-center justify-center overflow-hidden rounded-lg">
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    className="object-cover max-h-[130px] transition-transform duration-300 group-hover:scale-105"
                  />
                </div>

                {/* Title */}
                <h2 className="mt-2 text-xs font-semibold text-gray-800 text-center">
                  {item.name}
                </h2>

                {/* Buttons */}
                <div className="flex justify-center gap-2 mt-2">
                  <a
                    href={item.detailsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-2 py-1 text-[10px] border border-[#800000] text-[#800000] rounded-md hover:bg-[#800000] hover:text-white transition"
                  >
                    Know
                  </a>
                  <a
                    href={item.buyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-2 py-1 text-[10px] bg-[#800000] text-white rounded-md hover:bg-white hover:text-[#800000] border border-[#800000] transition"
                  >
                    Buy
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {premiumData.map((item) => (
              <div
                key={item.id}
                className="backdrop-blur-md bg-white/60 border border-gray-200 shadow-md rounded-t-xl flex flex-col items-center transition-transform hover:scale-105"
              >
                {/* Image */}
                <div className="w-full h-[280px] flex items-center justify-center rounded-t-xl overflow-hidden ">
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    className="object-cover max-h-[280px] transition-transform duration-300 group-hover:scale-110"
                  />
                </div>

                {/* Title */}
                <h2 className="mt-1 text-[14px] md:text-lg font-semibold text-gray-800 text-center">
                  {item.name}
                </h2>

                {/* Buttons */}
                <div className="flex justify-center gap-5 mt-1">
                  <a
                    href={item.detailsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-3 mb-2 py-1.5 text-sm border border-[#800000] text-[#800000] rounded-lg hover:bg-[#800000] hover:text-white transition"
                  >
                    Know More
                  </a>
                  <a
                    href={item.buyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-3 mb-2 py-1.5 text-sm bg-[#800000] text-white rounded-lg hover:bg-white hover:text-[#800000] border border-[#800000] transition"
                  >
                    Buy Now
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumProduct;
